import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { EditGrillePage } from "@/features/ventes/components/tarifs/EditGrillePage";

export const Route = createFileRoute("/_app/ventes/tarifs/$id/edit")({
  loader: requirePermission(PERMISSIONS.VENTES.TARIFS.EDIT),
  staticData: {
    title: "Modifier grille tarifaire",
    showInBreadcrumb: true,
  },
  component: EditGrillePage,
});
